import axios from 'axios';
import {  req } from './axiosFun';
export const userList = (params) => { return req("get", "/link/user/list", params) };
export const audit = (params) => { return req("put", "/link/user/audit", params) };
export const getUserInfo = (params) => { return req("get", "/link/user/get", params) };
export const getApplyInfo = (params) => { return req("get", "/link/user/getApplyInfo", params) };
export const getCards = (params) => { return req("get", "/link/user/getCardInfos", params) };
export const saveCards = (params) => { return req("post", "/link/user/saveCards", params) };




// WEBPACK FOOTER //
// ./src/api/user.js